import { render, staticRenderFns } from "./BillOfLadingForm.vue?vue&type=template&id=c4340436&scoped=true&"
import script from "./BillOfLadingForm.vue?vue&type=script&lang=js&"
export * from "./BillOfLadingForm.vue?vue&type=script&lang=js&"
import style0 from "./BillOfLadingForm.vue?vue&type=style&index=0&id=c4340436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4340436",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
